export class TipoMotivo {
    id?: number;
    descripcion?: string;

    copiar(objeto : any){
        this.id = objeto.id;
        this.descripcion = objeto.descripcion;
    }
}